export default "__VITE_ASSET__Ch6G3Btc__"